import CustomFormFactory from "../../../../components/CustomFormFactory/CustomFormFactory";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { restUseCase } from "../../../../usecases/rest";
import FormUtils from "../../../../utils/classUtils/FormUtils";
import withRouter from "../../../../utils/withRouter";
import NewsFormPresenter from "./NewsFormPresenter";

class NewsFormPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = { object: {}, modalState: false };
    this.presenter = new NewsFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase()
    );
  }

  getCollectionName() {
    return "news";
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      write: [user.id, "role:admin"],
    };
  }

  render() {
    const { fields, sections } = this.getSchema(this.getCollectionName());
    const { object } = this.state;

    return (
      <PageContainer title="Create News">
        <form onSubmit={this.onSubmitForm.bind(this)}>
          <CustomFormFactory
            schema={this.transformFieldsToSections({ fields, sections })}
            object={object}
            fieldsToExlude={this.fieldsToExclude}
            onChange={this.onChange.bind(this)}
            navigateBack={this.navigateBack.bind(this)}
          />
        </form>
      </PageContainer>
    );
  }
}

export default withRouter(NewsFormPage);
